import React, { useMemo } from 'react';
import TopNav, { TYPE_TopNav } from './TopNav/TopNav.tsx';
import Footer from './Footer/Footer.tsx';
import { useTranslation } from 'react-i18next';
import Menu, { WMOption } from '@/component/menu/Menu.tsx';
import LanguageIcon from '@/component/icon/LanguageIcon.tsx';

// 다국어 선택 컴포넌트 (TopNav가 없는 페이지용)
const LanguageSelector: React.FC = () => {
    const { i18n } = useTranslation();
    
    // 언어 변경하기
    const changeLanguage = (lang: string) => {
        i18n.changeLanguage(lang);
    };

    const languageItems: WMOption[] = useMemo(() => {
        return [
            { id: 'ko', text: '한국어', onClick: () => changeLanguage('ko') },
            { id: 'en', text: 'English', onClick: () => changeLanguage('en') },
            { id: 'ja', text: '日본語', onClick: () => changeLanguage('ja') }
        ];
    }, []);

    return (
        <div className="fixed top-4 right-4 z-50">
            <Menu items={languageItems} render={
                <div className={'flex gap-[10px]'}>
                    <div className={'text-[14px] select-none bg-gray-500 text-white rounded-full min-w-[40px] min-h-[40px] flex items-center justify-center'}>
                        <LanguageIcon className={'p-[9px]'} color="#ffffff" size={16} />
                    </div>
                </div>
            } />
        </div>
    );
};

type IProps = {
    className?: string;
    showTopNav?: boolean;
    showFooter?: boolean;
    typeTopNav?: TYPE_TopNav;
    children?: any;
};

const PageConfig: React.FC<IProps> = ({ className, showTopNav, showFooter, typeTopNav, children }) => {
    return (
        <div className={`flex flex-col h-screen relative ${className}`}>
            {/* 상단 네비게이션 */}
            {showTopNav && <TopNav className={''} type={typeTopNav} />}
            
            {/* 언어 선택 버튼 - TopNav가 없는 페이지에서만 표시 */}
            {!showTopNav && <LanguageSelector />}

            {/* 메인 컨텐츠 */}
            <main className="flex-1 overflow-auto">{children}</main>

            {/* 하단 네비게이션 (로그인 화면에서는 표시하지 않음) */}
            {showFooter && <Footer />}
        </div>
    );
};

export default PageConfig;
